module.exports = __webpack_public_path__ + "static/img/pay_pp_ex.68ab3121.png";